<rid-word-snake
  class="h-dvh"
  [snakes]="[
    [
      {
        words: ['hand', 'granaat'],
        audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/JEOE5HvotZVLUtbnIaXb0.mp3',
      },
      {
        words: ['granaat', 'appel'],
        audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/9CDLx_0IzhOzB4YS6MUAu.mp3',
      },
      {
        words: ['appel', 'taart'],
        audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/AhhrL7MRNc_dvWAsx7YIf.mp3',
      },
      {
        words: ['taart', 'doos'],
        audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/JEOE5HvotZVLUtbnIaXb0.mp3',
      },
    ],
    [
      {
        words: ['bureau', 'stoel'],
        audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/9CDLx_0IzhOzB4YS6MUAu.mp3',
      },
      {
        words: ['stoel', 'poot'],
        audio: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/AhhrL7MRNc_dvWAsx7YIf.mp3',
      },
    ],
  ]"
  (finished)="$router.navigate(['/mechanics/morphemes'])"
/>
